import * as LDClient from 'launchdarkly-js-client-sdk';
import 'constants/constants.json';

export const LaunchDarklyService = angular
    .module('LaunchDarklyService', [
        'app.constants'
    ]).factory('launchDarklyService', (
        $q,
        $rootScope,
        LAUNCH_DARKLY_KEY
    ) => {
        var client;
        var initialized = false;
        var initDeferred = $q.defer();

        var service = {
            updateUser: updateUser,
            init: init,
            getFeature: getFeature,
            getFeaturePromise: getFeaturePromise,
            allFlags: allFlags,
            getClient: getClient,
            waitForInit: waitForInit
        };

        function updateUser(newUser) {
            return service.waitForInit().then(() => {
                var deferred = $q.defer();
                client.identify(newUser, null, () => {
                    deferred.resolve();
                });
                return deferred.promise;
            });
        }

        function init(user) {
            if (initialized) {
                return $q.resolve();
            }
            if (!LDClient) {
                return $q.reject();
            }
            client = LDClient.initialize(LAUNCH_DARKLY_KEY, user);
            client.on('ready', () => {
                initialized = true;
                initDeferred.resolve();
                $rootScope.$apply();
            });

            return initDeferred.promise;
        }

        function getFeature(featureKey, defaultValue) {
            return service.waitForInit().then(() => {
                return client.variation(featureKey, defaultValue || false);
            });
        }

        function getFeaturePromise(featureKey, defaultValue) {
            return service.waitForInit().then(() => {
                return service.getFeature(featureKey, defaultValue || false).then((getsFeature) => {
                    return getsFeature ? $q.resolve() : $q.reject({ statusText: 'Unauthorized' });
                });
            });
        }

        function allFlags() {
            return service.waitForInit().then(() => client.allFlags());
        }

        function getClient() {
            return service.waitForInit().then(() => client);
        }

        function waitForInit() {
            if (initialized) {
                return $q.resolve();
            }
            return initDeferred.promise;
        }

        return service;
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/launchDarkly.service.js